import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useQueryClient } from 'react-query';
import { CircularProgress } from '@material-ui/core';

import { getMetaData, getAllCourses, getAllCourseEnrollments } from '../../api';

import CoursesTable from '../../components/coursesTable/CoursesTable';
import AddCourse from '../../components/addCourse/AddCourse';

const Courses = props => {
  const {
    addCoursesDialogOpen,
    addCourseModalScrollModuleIndex,
    addCourseModalScrollRestoreCount,
    addCourseModalScrollTop,
    onCoursesDialogOpen,
    onSetAddCourseModalScroll,
    onAddCourseModalScrollRestored,
    appname,
    isAppAdmin,
    onResetCourseData,
    onCourseItemChange,
    coursesItem,
    pages,
  } = props;

  const [currency, setCurrency] = useState('GBP');
  const queryClient = useQueryClient();

  const { data, isLoading: isLoadingData } = useQuery(
    ['onlineCourseMetaData', { appname }],
    getMetaData,
  );

  useEffect(() => {
    if (data) {
      setCurrency(data.currency || 'GBP');
    }
  }, [data]);

  // Prefetch courses and enrollments data as backup (in case Features page wasn't visited)
  // This ensures data starts loading immediately when Courses component mounts
  useEffect(() => {
    if (appname) {
      queryClient.prefetchQuery(
        ['courseItems', { appname }],
        getAllCourses,
        {
          staleTime: 30000,
          cacheTime: 300000,
        },
      );

      queryClient.prefetchQuery(
        ['courseEnrollments', { appname }],
        getAllCourseEnrollments,
        {
          staleTime: 30000,
          cacheTime: 300000,
        },
      );
    }
  }, [appname, queryClient]);

  if (isLoadingData) {
    return (
      <div style={{ margin: 'auto' }}>
        <CircularProgress color="primary" size={40} />;
      </div>
    );
  }

  return (
    <>
      {addCoursesDialogOpen && (
        <AddCourse
          addCourseModalScrollModuleIndex={addCourseModalScrollModuleIndex}
          addCourseModalScrollRestoreCount={addCourseModalScrollRestoreCount}
          addCourseModalScrollTop={addCourseModalScrollTop}
          appname={appname}
          addCouresDialogOpen={addCoursesDialogOpen}
          onCoursesDialogOpen={onCoursesDialogOpen}
          onCourseItemChange={onCourseItemChange}
          onSetAddCourseModalScroll={onSetAddCourseModalScroll}
          onAddCourseModalScrollRestored={onAddCourseModalScrollRestored}
          courseItem={coursesItem}
          onResetCourseData={onResetCourseData}
          currency={currency}
          pages={pages}
        />
      )}

      <CoursesTable
        appname={appname}
        isAppAdmin={isAppAdmin}
        onCoursesDialogOpen={onCoursesDialogOpen}
        onCoursesItemChange={onCourseItemChange}
        currency={currency}
      />
    </>
  );
};

Courses.propTypes = {
  addCoursesDialogOpen: PropTypes.bool.isRequired,
  addCourseModalScrollModuleIndex: PropTypes.number,
  addCourseModalScrollRestoreCount: PropTypes.number,
  addCourseModalScrollTop: PropTypes.number,
  onCoursesDialogOpen: PropTypes.func.isRequired,
  onSetAddCourseModalScroll: PropTypes.func,
  onAddCourseModalScrollRestored: PropTypes.func,
  appname: PropTypes.string.isRequired,
  onResetCourseData: PropTypes.func.isRequired,
  isAppAdmin: PropTypes.bool.isRequired,
  onCourseItemChange: PropTypes.func.isRequired,
  coursesItem: PropTypes.object.isRequired,
  pages: PropTypes.array.isRequired,
};

export default Courses;
